import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["actionType", "section"]

  connect() {
    this.update()
  }

  update() {
    if (!this.hasActionTypeTarget) return

    const selectedType = this.actionTypeTarget.value
    this.sectionTargets.forEach((section) => {
      const actionTypes = (section.dataset.actionTypes || "").split(/\s+/)
      const visible = actionTypes.includes(selectedType)
      section.classList.toggle("hidden", !visible)
      section.querySelectorAll("input, select, textarea").forEach((field) => {
        field.disabled = !visible
      })
    })
  }
}
